/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionSettlePageItemVo } from './CommissionSettlePageItemVo';
import {
    CommissionSettlePageItemVoFromJSON,
    CommissionSettlePageItemVoFromJSONTyped,
    CommissionSettlePageItemVoToJSON,
    CommissionSettlePageItemVoToJSONTyped,
} from './CommissionSettlePageItemVo';

/**
 * 
 * @export
 * @interface PageDataCommissionSettlePageItemVo
 */
export interface PageDataCommissionSettlePageItemVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataCommissionSettlePageItemVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataCommissionSettlePageItemVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataCommissionSettlePageItemVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<CommissionSettlePageItemVo>}
     * @memberof PageDataCommissionSettlePageItemVo
     */
    records?: Array<CommissionSettlePageItemVo>;
}

/**
 * Check if a given object implements the PageDataCommissionSettlePageItemVo interface.
 */
export function instanceOfPageDataCommissionSettlePageItemVo(value: object): value is PageDataCommissionSettlePageItemVo {
    return true;
}

export function PageDataCommissionSettlePageItemVoFromJSON(json: any): PageDataCommissionSettlePageItemVo {
    return PageDataCommissionSettlePageItemVoFromJSONTyped(json, false);
}

export function PageDataCommissionSettlePageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataCommissionSettlePageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CommissionSettlePageItemVoFromJSON)),
    };
}

export function PageDataCommissionSettlePageItemVoToJSON(json: any): PageDataCommissionSettlePageItemVo {
    return PageDataCommissionSettlePageItemVoToJSONTyped(json, false);
}

export function PageDataCommissionSettlePageItemVoToJSONTyped(value?: PageDataCommissionSettlePageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CommissionSettlePageItemVoToJSON)),
    };
}

